// Type for update operations that doesn't require all fields
export type UpdatePBMConnectionDTO = Partial<PBMConnection>;

export interface PBMConnection {
    remoteDestinationDirectory: string;
    remoteSourceDirectory: string;
    destinationContainerName: string;
    id: number;
    pbmId: number;
    ipAddress: string;
    userName: string;
    port: number;
    keyLocation?: string;
    outputMappingId: number;
    authType: 'Password' | 'PrivateKey';
    password?: string;
    keyPassphrase?: string;
}

import apiClient from '../utils/apiClient';

export const getConnectionsByPbmId = async (pbmId: number): Promise<PBMConnection[]> => {
    try {
        return await apiClient.get<PBMConnection[]>(`api/PBMConnection?pbmId=${pbmId}`);
    } catch (error) {
        console.error('Error fetching PBM connections:', error);
        throw error;
    }
};

// Type for create operations that includes required fields but omits id
export type CreatePBMConnectionDTO = Omit<PBMConnection, 'id'>;

export const createConnection = async (connection: CreatePBMConnectionDTO): Promise<PBMConnection> => {
    try {
        return await apiClient.post<PBMConnection>('api/PBMConnection', connection);
    } catch (error) {
        console.error('Error creating PBM connection:', error);
        throw error;
    }
};

export interface UpdatePasswordDTO {
    currentPassword: string;
    newPassword: string;
}

export interface UpdateKeyPassphraseDTO {
    currentPassphrase: string;
    newPassphrase: string;
}

export interface ConnectionCredentialsDTO {
    connectionId: number;
    authType: 'Password' | 'PrivateKey';
    password?: string;
    keyLocation?: string;
    keyPassphrase?: string;
}

export const updateConnection = async (id: number, connection: UpdatePBMConnectionDTO): Promise<void> => {
    try {
        await apiClient.patch(`api/PBMConnection/${id}`, connection);
    } catch (error) {
        console.error('Error updating PBM connection:', error);
        throw error;
    }
};

export const updateConnectionCredentials = async (id: number, credentials: ConnectionCredentialsDTO): Promise<PBMConnection> => {
    try {
        return await apiClient.post<PBMConnection>(`api/PBMConnection/${id}/credentials`, credentials);
    } catch (error) {
        console.error('Error updating connection credentials:', error);
        throw error;
    }
};

export const updatePassword = async (id: number, passwordUpdate: UpdatePasswordDTO): Promise<void> => {
    try {
        await apiClient.patch(`api/PBMConnection/${id}/password`, passwordUpdate);
    } catch (error) {
        console.error('Error updating password:', error);
        throw error;
    }
};

export const updateKeyPassphrase = async (id: number, passphraseUpdate: UpdateKeyPassphraseDTO): Promise<void> => {
    try {
        await apiClient.patch(`api/PBMConnection/${id}/keypassphrase`, passphraseUpdate);
    } catch (error) {
        console.error('Error updating key passphrase:', error);
        throw error;
    }
};

export const deleteConnection = async (id: number): Promise<void> => {
    try {
        await apiClient.delete(`api/PBMConnection/${id}`);
    } catch (error) {
        console.error('Error deleting PBM connection:', error);
        throw error;
    }
};
